import * as Collections from '@pkg/utils/collections';

/**
 * @param {Object} property
 * @param {Array} options
 */
export default function mutate(property, options) {
  const mutation = {
    create: [],
    update: [],
    remove: [],
  };

  const propertyOptions = structuredClone(property?.options ?? []);
  const currentOptions = new Map(propertyOptions.map((opt) => [opt.uuid, opt]));
  let isDifferent = false;

  options.forEach((option) => {
    const existing = currentOptions.get(option.uuid);

    if (!existing) {
      mutation.create.push(option);
      isDifferent = true;
      return;
    }

    const changed = { uuid: option.uuid };
    if (option.value !== existing.value) {
      changed.value = option.value;
    }
    if (option.order !== existing.order) {
      changed.order = option.order;
    }
    if ((option.color ?? null) !== (existing.color ?? null)) {
      changed.color = option.color ?? null;
    }

    if (Object.keys(changed).length > 1) {
      mutation.update.push(changed);
      isDifferent = true;
    }
  });

  const keyedOptions = Collections.keyById(options);

  currentOptions.forEach((option) => {
    if (!keyedOptions[option.uuid]) {
      mutation.remove.push(option.uuid);
      isDifferent = true;
    }
  });

  if (!isDifferent) {
    return null;
  }

  return mutation;
}
